import React from 'react';

import cx from 'classnames';

import Button from 'components/Button';

import styles from './styles.module.scss';

const Stepper = ({
  nextButtonText,
  backButtonText,
  onNextClick,
  activeTab,
  disableNextButton,
  onBackClick,
  disableConfirm = false,
  hideBackButton = false
}) => {
  return (
    <>
      <div className={styles.buttonContainer}>
        {hideBackButton ? (
          <div />
        ) : (
          <Button
            className={styles.backButton}
            color="lightGrey"
            onClick={() => onBackClick()}
          >
            {backButtonText}
          </Button>
        )}
        <Button
          color="pink"
          disabled={disableNextButton}
          className={styles.nextButton}
          onClick={onNextClick}
          data-intercom-target="Assignment Create Dialog Assign Button"
        >
          {nextButtonText}
        </Button>
      </div>

      <div className={styles.navTabs}>
        <button
          type="button"
          className={cx(styles.tab, {
            [styles.active]: activeTab === 'upload'
          })}
        >
          Choose Type
        </button>
        <button
          type="button"
          className={cx(styles.tab, {
            [styles.active]: activeTab === 'create',
            [styles.withOpacity]: activeTab === 'choose'
          })}
        >
          Create
        </button>
        {!disableConfirm && (
          <button
            type="button"
            className={cx(styles.tab, {
              [styles.active]: activeTab === 'confirm',
              [styles.withOpacity]:
                activeTab === 'choose' || activeTab === 'create'
            })}
          >
            Confirm
          </button>
        )}
        <button
          type="button"
          className={cx(styles.tab, {
            [styles.active]: activeTab === 'assign',
            [styles.withOpacity]:
              activeTab === 'choose' ||
              activeTab === 'create' ||
              activeTab === 'confirm'
          })}
        >
          Assign
        </button>
      </div>
    </>
  );
};

export default Stepper;
